export default {
  apiKey: "AIzaSyBmGJ-npGxle938vgHkNceM1zqtRyKMnh8",
  authDomain: "dukeinventory.firebaseapp.com",
  projectId: "dukeinventory",
  storageBucket: "dukeinventory.firebasestorage.app",
  messagingSenderId: "901460252118",
  appId: "1:901460252118:web:d8ff47d131f180abed8077"
};